import { CalendarCheck, X } from "lucide-react";

const rs = (n) => `₹${Math.round(Number(n || 0)).toLocaleString("en-IN")}`;
const fd = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("en-GB", { day: "2-digit", month: "short" }) : "");

/* Monday summary banner for team leaders (last 7 days). */
export const LeaderWeekly = ({ d, onClose }) => {
  const s = d.summary || {};
  const tiles = [["Parcels", s.parcels, s.trend == null ? "" : `${s.trend > 0 ? "+" : ""}${s.trend}% vs week before`],
    ["Completed", s.completed, `${s.in_process || 0} in process · ${s.pending || 0} received`],
    ["Money due", rs(s.due), `sales ${rs(s.sales)} · paid ${rs(s.payments)}`],
    ["Open notes", d.open_notes, `${s.queries_open || 0} open queries · ${s.refills_due || 0} refills due`]];
  return (
    <div className="relative mb-4 overflow-hidden rounded-xl border border-indigo-200 bg-gradient-to-r from-indigo-50 to-white p-4" data-testid="leader-weekly">
      <button onClick={onClose} className="absolute right-2 top-2 rounded p-1 text-slate-400 hover:bg-white" data-testid="leader-weekly-close"><X className="h-4 w-4" /></button>
      <p className="flex items-center gap-2 text-sm font-bold text-indigo-900"><CalendarCheck className="h-4 w-4" />Your team's week (from {fd(d.week)})</p>
      <div className="mt-3 grid grid-cols-2 gap-2 md:grid-cols-4">{tiles.map(([l, v, sub]) => (
        <div key={l} className="rounded-lg border bg-white p-2.5" data-testid={`leader-weekly-${l.toLowerCase().replace(/\s+/g, "-")}`}>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{l}</p>
          <p className="text-xl font-bold text-slate-900">{v ?? 0}</p>
          <p className="text-[11px] text-slate-500">{sub}</p></div>))}</div>
      <p className="mt-2 text-xs text-slate-600">{d.best && <>Top code: <b>{d.best}</b>. </>}{d.quiet?.length ? <>No orders last week: <b>{d.quiet.join(", ")}</b> — worth a call.</> : "Every code ordered last week."}</p>
    </div>
  );
};
